<template>
  <section class="hero">
    <div class="hero__inner">
      <div class="hero__logo" :class="{ 'hero__logo_visible': mounted }" aria-hidden="true" />
      <h1 class="hero__title" :class="{ 'hero__title_visible': mounted }">
        Картины, которые притягивают деньги
      </h1>
      <p class="hero__subtitle" :class="{ 'hero__subtitle_visible': mounted }">
        Мы делаем Арт с денежной энергией и мотивационными смыслами —<br />
        для дома, офиса и мышления победителя.
      </p>
      <div class="hero__actions" :class="{ 'hero__actions_visible': mounted }">
        <!-- <router-link to="/catalog" class="hero__btn hero__btn_primary">
          Выбрать картину
        </router-link> -->
        <router-link to="/catalog" class="hero__btn hero__btn_secondary">
          Посмотреть витрину
        </router-link>
      </div>
      <div class="hero__squares" :class="{ 'hero__squares_visible': mounted }">
        <div
          v-for="(item, i) in labelItems"
          :key="item.word"
          class="hero__square"
          :style="{ transitionDelay: `${0.35 + i * 0.08}s` }"
        >
          <span class="hero__square-icon" aria-hidden="true" v-html="item.icon" />
          <span class="hero__square-word">{{ item.word }}</span>
        </div>
      </div>
    </div>
    <div class="hero__overlay" aria-hidden="true" />
    <div class="hero__noise" aria-hidden="true" />
  </section>
</template>

<script>
import { ref, onMounted } from 'vue'

export default {
  name: 'HomeHero',
  setup() {
    const mounted = ref(false)
    const labelItems = [
      {
        word: 'ДОСТАТОК',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>'
      },
      {
        word: 'ЭНЕРГИЯ',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>'
      },
      {
        word: 'МОТИВАЦИЯ',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg>'
      }
    ]
    onMounted(() => {
      requestAnimationFrame(() => { mounted.value = true })
    })
    return { mounted, labelItems }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/_variables.scss";

$hero-duration: 0.8s;
$hero-ease: cubic-bezier(0.22, 1, 0.36, 1);

.hero {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 8vh;
  background: $color-bg-alt url(~@/assets/mainbg.jpg) center / cover no-repeat;
  color: $color-primary-inverse;
  overflow: hidden;

  @media (max-width: $breakpoint-tablet) {
    padding-top: 14vh;
  }

  @media (max-width: $breakpoint-mobile) {
    padding-top: 12vh;
  }

  &__inner {
    position: relative;
    z-index: 1;
    max-width: $container-max;
    margin: 0 auto;
    padding: 32px $gap 56px;
    text-align: center;

    @media (max-width: $breakpoint-tablet) {
      padding: 48px $gap 64px;
    }

    @media (max-width: $breakpoint-mobile) {
      padding: 56px $gap 64px;
    }
  }

  &__logo {
    display: block;
    width: 570px;
    height: 183px;
    margin: 0 auto 20px;
    background-image: url(~@/assets/logo.png);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0;
    transform: translateY(24px);
    transition: opacity $hero-duration $hero-ease, transform $hero-duration $hero-ease;

    &_visible {
      opacity: 1;
      transform: translateY(0);
    }

    @media (max-width: $breakpoint-mobile) {
      width: 420px;
      height: 135px;
      margin-bottom: 16px;
    }
  }

  &__title {
    font-size: clamp(32px, 5vw, 56px);
    font-weight: 800;
    line-height: 1.15;
    letter-spacing: -0.02em;
    margin: 0 0 14px;
    opacity: 0;
    transform: translateY(32px);
    transition: opacity $hero-duration $hero-ease, transform $hero-duration $hero-ease;

    &_visible {
      opacity: 1;
      transform: translateY(0);
    }

    @media (max-width: $breakpoint-mobile) {
      margin-bottom: 12px;
    }
  }

  &__subtitle {
    font-size: clamp(16px, 2.2vw, 20px);
    line-height: 1.6;
    opacity: 0.6;
    margin: 0 0 28px;
    max-width: 560px;
    margin-left: auto;
    margin-right: auto;
    opacity: 0;
    transform: translateY(24px);
    transition: opacity $hero-duration $hero-ease 0.1s, transform $hero-duration $hero-ease 0.1s;

    &_visible {
      opacity: 0.85;
      transform: translateY(0);
    }

    @media (max-width: $breakpoint-mobile) {
      margin-bottom: 24px;
      br { display: none; }
    }
  }

  &__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: center;
    margin-bottom: 24px;
    opacity: 0;
    transform: translateY(24px);
    transition: opacity $hero-duration $hero-ease 0.2s, transform $hero-duration $hero-ease 0.2s;

    &_visible {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &__btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 16px 28px;
    font-size: 16px;
    font-weight: 600;
    text-decoration: none;
    border-radius: 50px;
    transition: transform 0.2s, box-shadow 0.2s;

    &_primary {
      background: $color-primary-inverse;
      color: $color-primary;
      box-shadow: 0 4px 24px rgba(255, 255, 255, 0.2);

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 32px rgba(255, 255, 255, 0.25);
      }
    }

    &_secondary {
      background: transparent;
      color: $color-primary-inverse;
      border: 2px solid rgba(255, 255, 255, 0.5);

      &:hover {
        border-color: $color-primary-inverse;
        transform: translateY(-2px);
      }
    }
  }

  &__squares {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 24px;
    margin: 0;
    padding-top: 4px;

    @media (max-width: $breakpoint-mobile) {
      gap: 16px;
      padding-top: 0;
    }

    &_visible .hero__square {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &__square {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: 88px;
    flex-shrink: 0;
    opacity: 0;
    transform: translateY(14px);
    transition: opacity $hero-duration $hero-ease, transform $hero-duration $hero-ease;

    @media (max-width: $breakpoint-mobile) {
      width: 76px;
      gap: 10px;
    }
  }

  &__square-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 14px;
    color: $color-accent-teal;
    flex-shrink: 0;

    :deep(svg) {
      width: 28px;
      height: 28px;
    }

    @media (max-width: $breakpoint-mobile) {
      width: 56px;
      height: 56px;
      border-radius: 12px;
      :deep(svg) { width: 24px; height: 24px; }
    }
  }

  &__square-word {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.06em;
    color: rgba(255, 255, 255, 0.9);
    text-align: center;

    @media (max-width: $breakpoint-mobile) {
      font-size: 11px;
    }
  }

  &__overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    pointer-events: none;
  }

  &__noise {
    position: absolute;
    inset: 0;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.04'/%3E%3C/svg%3E");
    pointer-events: none;
  }
}
</style>
